import React, { useRef } from "react"
import uuid from "uuid/v4"
import { css, keyframes } from "@emotion/core"

const infiniteFadeAnimation = keyframes`
  from { opacity: .3; }
`
const infiniteFade = css({
  animation: `${infiniteFadeAnimation} ease-in-out .5s infinite alternate`,
})

export function DeploymentPending(props) {
  const idRef = useRef(uuid())
  const id = `deployment-pending-${idRef?.current}`

  return (
    <svg
      css={infiniteFade}
      data-testid="deployment-pending"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Pending deployment</title>
      <rect width="20" height="20" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1C13.0333 1 15.5583 3.15833 16.125 6.03333C18.2917 6.18333 20 7.96667 20 10.1667C20 12.4108 18.2228 14.2425 16 14.3301V12.6612C17.3053 12.5758 18.3333 11.494 18.3333 10.1667C18.3333 8.78333 17.2167 7.66667 15.8333 7.66667H14.5833V7.25C14.5833 4.71667 12.5333 2.66667 10 2.66667C7.9 2.66667 6.14167 4.075 5.59167 6H5C3.15833 6 1.66667 7.49167 1.66667 9.33333C1.66667 10.8266 2.64729 12.0897 4 12.5142V14.233C1.71969 13.7689 0 11.7493 0 9.33333C0 6.75833 1.95 4.63333 4.45833 4.36667C5.5 2.36667 7.59167 1 10 1Z"
        fill="#B7B5BD"
      />
      <path
        d="M13.5404 11.6238L9.91662 8L6.29285 11.6238"
        stroke="#B7B5BD"
        strokeWidth="1.5"
      />
      <path
        d="M9.91675 18.8335V8.8335"
        stroke={`url(#${id})`}
        strokeWidth="1.5"
      />
      <defs>
        <linearGradient
          id={id}
          x1="10.4167"
          y1="8.8335"
          x2="10.4167"
          y2="18.8335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B7B5BD" />
          <stop offset="1" stopColor="#78757A" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
